import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueTypesScreenSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-view',
	path: '/jira/settings/issues/issue-type-screen-schemes',
};
